/* eslint-disable react-hooks/exhaustive-deps */
import Chart from 'react-google-charts';
import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, CardText, Col, Container, Row } from 'reactstrap'
import './AdminDashboard.css'
import { useDispatch } from 'react-redux';
import { getDCData } from '../../actions/EpikBoxes';
import NotAssessableCommon from '../../components/NotAssessableCommon'; // use if any page needs pin protection

const AdminDashboard = () => {
  const token = localStorage.getItem('jwtToken') || null;
  const dispatch = useDispatch();

  const [graphLosAngeles, setGraphLosAngeles] = useState([]);
  const [graphChicago, setGraphChicago] = useState([]);
  const [graphNewYork, setGraphNewYork] = useState([]);
  const [graphAtlanta, setGraphAtlanta] = useState([]);
  const [graphDallas, setGraphDallas] = useState([]);
  const [latency, setLatency] = useState([]);
  const normalizePieData = (data) => {
    if (!data || data.length < 3) return data;
    const registered = Number(data[1][1]) || 0;
    const unregistered = Number(data[2][1]) || 0;
    const total = registered + unregistered;
    if (total === 0) {
      return [
        [
          { type: 'string', label: 'Task' },
          { type: 'number', label: 'Count' },
          { type: 'string', role: 'tooltip', p: { html: true } }
        ],
        ['No Data', 1, 'No Data: 0 (0%)'],
      ];
    }
    return data;
  };
  const isNoData = (data) => {
    if (!data || data.length < 3) return false;
    const registered = Number(data[1][1]) || 0;
    const unregistered = Number(data[2][1]) || 0;
    return registered + unregistered === 0;
  };

  const getAdminDashboardData = async () => {
    const res = await dispatch(getDCData(token));

    if (res) {
      const losUnRegistered = res.nonRegisteredEpikBoxCount.find(item => item._id === 'la');
      const losRegistered = res.registeredEpikBoxCount.find(item => item._id === 'la');
      const chicagoUnRegistered = res.nonRegisteredEpikBoxCount.find(item => item._id === 'ch');
      const chicagoRegistered = res.registeredEpikBoxCount.find(item => item._id === 'ch');
      const newYorkUnRegistered = res.nonRegisteredEpikBoxCount.find(item => item._id === 'ny');
      const newYorkRegistered = res.registeredEpikBoxCount.find(item => item._id === 'ny');
      const dallasUnRegistered = res.nonRegisteredEpikBoxCount.find(item => item._id === 'dl');
      const dallasRegistered = res.registeredEpikBoxCount.find(item => item._id === 'dl');
      const atlantaUnRegistered = res.nonRegisteredEpikBoxCount.find(item => item._id === 'at');
      const atlantaRegistered = res.registeredEpikBoxCount.find(item => item._id === 'at');
      setLatency(res?.averageDatacenterLatency || []);
      const losAngelesData = [
        ['Task', 'Hours per Day'],
        ['Registered', losRegistered?.count || 0],
        ['UnRegistered', losUnRegistered?.count || 0],
      ];
      const chicagoData = [
        ['Task', 'Hours per Day'],
        ['Registered', chicagoRegistered?.count || 0],
        ['UnRegistered', chicagoUnRegistered?.count || 0],
      ];
      const newYorkData = [
        ['Task', 'Hours per Day'],
        ['Registered', newYorkRegistered?.count || 0],
        ['UnRegistered', newYorkUnRegistered?.count || 0],
      ];
      const dallasData = [
        ['Task', 'Hours per Day'],
        ['Registered', dallasRegistered?.count || 0],
        ['UnRegistered', dallasUnRegistered?.count || 0],
      ];
      const altantaData = [
        ['Task', 'Hours per Day'],
        ['Registered', atlantaRegistered?.count || 0],
        ['UnRegistered', atlantaUnRegistered?.count || 0],
      ];
      setGraphLosAngeles(losAngelesData);
      setGraphChicago(chicagoData);
      setGraphNewYork(newYorkData);
      setGraphAtlanta(altantaData)
      setGraphDallas(dallasData)
    }
  };

  useEffect(() => {
    getAdminDashboardData();
  }, []);

  // const onSuccess = status => {
  //   setProtectedData(status);
  // };

  const twoDecimal = num => {
    if (typeof num === 'string') {
      num = parseFloat(num);
    }
    return Math.round((num + Number.EPSILON) * 100) / 100;
  };

  return (
    <Container fluid style={{ margin: 0 }}>
      <div className="viewContainer" style={{ marginTop: '20px' }}>
        <Row className="mt-3 ">
          <Col md={4} sm={12}>
            <div style={{ textAlign: 'center' }}>
              <h3 className="chartTitle">Los Angeles Data Center Load</h3>
              {/* Center the chart container with margin: 0 auto; */}
              <Chart
                chartType="PieChart"
                width="100%"
                height="400px"
                data={normalizePieData(graphLosAngeles)}
                options={{
                  pieHole: 0.4,
                  is3D: false,
                  legend: { position: 'bottom' },
                  chartArea: {
                    left: '5%',
                    top: 40,
                    width: '100%',
                    height: '70%',
                  },
                  colors: isNoData(graphLosAngeles) ? ['#cdcdcd'] : undefined,
                }}
              />

            </div>
          </Col>
          <Col md={4} sm={12}>
            <div style={{ textAlign: 'center' }}>
              <h3 className="chartTitle">Chicago Data Center Load</h3>
              <div style={{ maxWidth: '500px', margin: '0 auto' }}>

                <Chart
                  chartType="PieChart"
                  width="100%"
                  height="400px"
                  data={normalizePieData(graphChicago)}
                  options={{
                    pieHole: 0.4,
                    is3D: false,
                    legend: { position: 'bottom' },
                    chartArea: {
                      left: '5%',
                      top: 40,
                      width: '100%',
                      height: '70%',
                    },
                    colors: isNoData(graphChicago) ? ['#cdcdcd'] : undefined,
                  }}
                />
              </div>
            </div>
          </Col>
          <Col md={4} sm={12}>
            <div style={{ textAlign: 'center' }}>
              <h3 className="chartTitle">New York Data Center Load</h3>
              <div style={{ maxWidth: '500px', margin: '0 auto' }}>
                <Chart
                  chartType="PieChart"
                  width="100%"
                  height="400px"
                  data={normalizePieData(graphNewYork)}
                  options={{
                    pieHole: 0.4,
                    is3D: false,
                    legend: { position: 'bottom' },
                    chartArea: {
                      left: '5%',
                      top: 40,
                      width: '100%',
                      height: '70%',
                    },
                    colors: isNoData(graphNewYork) ? ['#cdcdcd'] : undefined,
                  }}
                />
              </div>
            </div>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md={12} sm={12} className="d-flex justify-content-around align-items-center ">
            <Card
              className="my-2"
              color="info"
              outline
              style={{
                width: '18rem',
              }}
            >
              <CardHeader tag="h3">Los Angeles Average Data Center Latency</CardHeader>
              <CardBody>
                <CardText tag="h6">
                  {latency[0]?.laPingAvg ? twoDecimal(latency[0]?.laPingAvg) + `ms` : `N/A`}
                </CardText>
              </CardBody>
            </Card>
            <Card
              className="my-2"
              color="info"
              outline
              style={{
                width: '18rem',
              }}
            >
              <CardHeader tag="h3">Chicago Average Data Center Latency</CardHeader>
              <CardBody>
                <CardText tag="h6">
                  {latency[0]?.chPingAvg ? twoDecimal(latency[0]?.chPingAvg) + `ms` : `N/A`}
                </CardText>
              </CardBody>
            </Card>
            <Card
              className="my-2"
              color="info"
              outline
              style={{
                width: '18rem',
              }}
            >
              <CardHeader tag="h3">New York Average Data Center Latency</CardHeader>
              <CardBody>
                <CardText tag="h6">
                  {latency[0]?.nyPingAvg ? twoDecimal(latency[0]?.nyPingAvg) + `ms` : `N/A`}
                </CardText>
              </CardBody>
            </Card>
            {/* <Card
              className="my-2"
              color="info"
              outline
              style={{
                width: '18rem'
              }}
            >
              <CardHeader tag="h3">
                Atlanta Data Center Latency
              </CardHeader>
              <CardBody>
                <CardText tag="h6">
                  242ms
                </CardText>
              </CardBody>
            </Card> */}
          </Col>
        </Row>
        <Row className="mt-3 ">
          <Col md={4} sm={12}>
            <div style={{ textAlign: 'center' }}>
              <h3 className="chartTitle">Dallas Data Center Load</h3>
              <div style={{ maxWidth: '500px', margin: '0 auto' }}>
                <Chart
                  chartType="PieChart"
                  width="100%"
                  height="400px"
                  data={normalizePieData(graphDallas)}
                  options={{
                    pieHole: 0.4,
                    is3D: false,
                    legend: { position: 'bottom' },
                    chartArea: {
                      left: '5%',
                      top: 40,
                      width: '100%',
                      height: '70%',
                    },
                    colors: isNoData(graphDallas) ? ['#cdcdcd'] : undefined,
                  }}
                />
              </div>
            </div>
          </Col>
          <Col md={4} sm={12}>
            <div style={{ textAlign: 'center' }}>
              <h3 className="chartTitle">Atlanta Data Center Load</h3>
              <div style={{ maxWidth: '500px', margin: '0 auto' }}>
                <Chart
                  chartType="PieChart"
                  width="100%"
                  height="400px"
                  data={normalizePieData(graphAtlanta)}
                  options={{
                    pieHole: 0.4,
                    is3D: false,
                    legend: { position: 'bottom' },
                    chartArea: {
                      left: '5%',
                      top: 40,
                      width: '90%',
                      height: '70%',
                    },
                    colors: isNoData(graphAtlanta) ? ['#cdcdcd'] : undefined,
                  }}
                />
              </div>
            </div>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md={8} sm={10} className="d-flex justify-content-around align-items-center ">
            <Card
              className="my-2"
              color="info"
              outline
              style={{
                width: '18rem',
              }}
            >
              <CardHeader tag="h3">Dallas Average Data Center Latency</CardHeader>
              <CardBody>
                <CardText tag="h6">
                  {latency[0]?.dlPingAvg ? twoDecimal(latency[0]?.dlPingAvg) + `ms` : `N/A`}
                </CardText>
              </CardBody>
            </Card>
            <Card
              className="my-2"
              color="info"
              outline
              style={{
                width: '18rem',
              }}
            >
              <CardHeader tag="h3">Atlanta Average Data Center Latency</CardHeader>
              <CardBody>
                <CardText tag="h6">
                  {latency[0]?.atPingAvg ? twoDecimal(latency[0]?.atPingAvg) + `ms` : `N/A`}
                </CardText>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="seperator" />
      </div>
    </Container>
  );
};

export default AdminDashboard
